import React from 'react';
import { useAppSelector } from '../../store/reducers/store';
import { Box, Typography } from '@mui/material';
import BackButton from '../../components/common/BackButton';
import { useTranslation } from 'react-i18next';
import ReportsList from '../../components/portfolioDetailsReports/ReportsList';
import { useParams } from 'react-router-dom';

const ListOfFundsReportsPage: React.FC = () => {
    const {id} = useParams();
    const idAsNumber = parseInt(`${id}`);
    const allFunds = useAppSelector(state => state.libraryOfFundsReducer.allFunds);
    const { t } = useTranslation();

    const fund = allFunds && !isNaN(idAsNumber) ? allFunds.filter(f => f.id === idAsNumber) : undefined;

    if (fund === undefined || fund.length === 0){
        return <></>;
    }

    return <Box display={"flex"} margin={"0"} justifyContent={"center"} overflow={"auto"}>
    <Box display={"flex"} margin={"50px 56px"} alignItems={"center"} flexDirection={"column"} width={"100%"} maxWidth={"1396px"} gap={"27px"}>
        <Box display={"flex"} gap={"12px"} alignItems={"center"} width={"100%"}>
            <BackButton />
            <Typography fontSize={"20px"} fontWeight={"500"} lineHeight={"24.38px"} textAlign={"center"}>{t('PortfolioDetailsDataRoomsPageTitle')}</Typography>
        </Box>
        <ReportsList reports={ fund[0].dataRooms} />
    </Box>
</Box>;
}

export default ListOfFundsReportsPage;